import classNames from 'classnames'

import RouterLink from '../../../../../common/RouterLink/RouterLink'
import SvgIcon from '../../../../../common/SvgIcon/SvgIcon'
import type {Link} from '../Breadcrumbs.types'

import styles from './BreadcrumbsLink.css'

type Props = Link & {
  className?: string
}

export default function BreadcrumbsLink({className, to, name, rightIcon}: Props) {
  const common = {
    className: classNames(className, styles.link),
    title: name,
  }

  const content = (
    <>
      <span>{name}</span>
      {rightIcon != null ? <SvgIcon icon={rightIcon} className={styles.rightIcon} /> : null}
    </>
  )

  if (to == null) {
    return <div {...common}>{content}</div>
  }

  return (
    <RouterLink {...common} to={to}>
      {content}
    </RouterLink>
  )
}
